// Write your code here.
import './index.css'

const EmojiCard = props => {
  const {emoji, emojiSelect} = props
  const {id, emojiName, emojiUrl} = emoji
  const select = () => {
    emojiSelect(id)
  }
  // console.log(id)
  return (
    <li className="list">
      <button>
        <img
          className="emoji_image"
          onClick={select}
          alt={emojiName}
          src={emojiUrl}
        />
      </button>
    </li>
  )
}
export default EmojiCard
